import { useState } from 'react';
import { getListedCfdLogo } from '../constants/listedCfdLogos';

interface ListedCfdLogoProps {
  symbol: string;
  className?: string;
}

export default function ListedCfdLogo({ symbol, className = 'w-7 h-7' }: ListedCfdLogoProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const logo = getListedCfdLogo(symbol);

  if (!logo) return null;

  return (
    <span className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-slate-200 bg-white ${className}`}>
      {failedSrc === logo.src ? (
        <span role="img" aria-label={`${logo.name} logo`} className="text-[9px] font-bold text-slate-700">
          {logo.fallback}
        </span>
      ) : (
        <img
          src={logo.src}
          alt={`${logo.name} logo`}
          width={56}
          height={56}
          className="h-full w-full object-contain"
          onError={() => setFailedSrc(logo.src)}
        />
      )}
    </span>
  );
}
